
export default function Steps() {
  const steps = [
    {
      title: "Contadores e Departamento Pessoal/RH",
      icon: "ri-user-line",
      description: "Simplifique rotinas trabalhistas e evite erros que custam caro"
    },
    {
      title: "Advogados", 
      icon: "ri-scales-3-line",
      description: "Cálculos precisos para consultorias jurídicas"
    },
    {
      title: "Empresários",
      icon: "ri-building-line", 
      description: "Façam cálculos de pontos internamente e compartilhe com seu contador"
    },
    {
      title: "Trabalhadores CLT",
      icon: "ri-team-line",
      description: "Confira sua rescisāo"
    }
  ];

  return (
    <section className="py-20 md:py-32 px-4 bg-white">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-6">
            <span className="bg-teal-600 text-white px-4 py-2 rounded-lg">Para quem</span> é o CalculaDP?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Profissionais que trabalham com cálculos de ponto e cálculos trabalhistas e precisam 
            de agilidade, precisão e relatórios confiáveis.
          </p>
        </div>

        {/* Imagem central */}
        <div className="text-center mb-16">
          <img 
            src="https://static.readdy.ai/image/da7665bf3996c3ea364553a32910e66f/720527b4ccfbe6c13e23d8ede09714be.png" 
            alt="CalculaDP em uso" 
            className="w-full max-w-3xl mx-auto rounded-2xl shadow-xl"
          />
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {steps.map((step, index) => (
            <div 
              key={index}
              className="bg-gray-50 rounded-2xl p-8 hover:bg-gray-100 transition-all transform hover:-translate-y-2"
            >
              <div className="text-center">
                <div className="bg-teal-100 p-4 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-6">
                  <i className={`${step.icon} text-2xl text-teal-600`}></i>
                </div>
                <h3 className="text-xl font-bold mb-4 text-gray-900">{step.title}</h3>
                <p className="text-gray-600 leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="text-center mt-16 bg-gradient-to-r from-teal-50 to-cyan-50 rounded-3xl p-8 md:p-12 border border-teal-100">
          <h3 className="text-3xl font-bold text-gray-900 mb-4">
            Independente do seu perfil profissional
          </h3>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            O CalculaDP vai economizar seu tempo e eliminar erros nos seus cálculos trabalhistas
          </p>
          <a 
            href="https://calculadp.tiagonogueira.com.br/ponto" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-block bg-teal-600 hover:bg-teal-700 text-white px-10 py-4 rounded-xl text-lg font-bold shadow-lg hover:shadow-xl transition-all transform hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-arrow-right-line mr-2"></i>
            Quero Começar Agora
          </a>
        </div>
      </div>
    </section>
  );
}
